module.exports = __webpack_public_path__ + "img/7.14d7e201.webp";